/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type AgentCrashRollback = {
  /**
   * Version that failed to stabilize.
   */
  from?: string | undefined;
  /**
   * Version restored.
   */
  to?: string | undefined;
};

/** @internal */
export type AgentCrashRollback$Outbound = {
  from?: string | undefined;
  to?: string | undefined;
};

/** @internal */
export const AgentCrashRollback$outboundSchema: z.ZodMiniType<
  AgentCrashRollback$Outbound,
  AgentCrashRollback
> = z.object({
  from: z.optional(z.string()),
  to: z.optional(z.string()),
});

export function agentCrashRollbackToJSON(
  agentCrashRollback: AgentCrashRollback,
): string {
  return JSON.stringify(
    AgentCrashRollback$outboundSchema.parse(agentCrashRollback),
  );
}
